// this area is reserved for action types that request API endpoints
export const REQ_USER_AGREEMENT_GET = 'REQ_USER_AGREEMENT_GET';
export const REQ_USER_AGREEMENT_ACCEPTED_SET = 'REQ_USER_AGREEMENT_ACCEPTED_SET';
export const REQ_USER_AGREEMENT_ACCEPTED_GET = 'REQ_USER_AGREEMENT_ACCEPTED_GET';

// this area is for client only action types (no API calls happen here) --- Seriously None!!!
export const CLIENT_USER_AGREEMENT_STOWE = 'CLIENT_USER_AGREEMENT_STOWE';
export const CLIENT_USER_HAS_NOT_AGREED_YET = 'CLIENT_USER_HAS_NOT_AGREED_YET';
export const CLIENT_USER_HAS_AGREED = 'CLIENT_USER_HAS_AGREED';
